"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function req(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M17.1025 5.65698C17.1687 5.65552 17.2346 5.66753 17.2961 5.69228C17.3576 5.71704 17.4134 5.75401 17.4602 5.80098L17.4557 5.79648C17.5298 5.87032 17.5782 5.96603 17.5937 6.06948L17.6005 6.14748L17.5952 8.71023C17.5952 9.04698 17.4617 9.37023 17.2232 9.60798L14.0432 12.7782L17.446 16.1705C17.5656 16.2874 17.661 16.4269 17.7264 16.5809C17.7919 16.7349 17.8261 16.9004 17.8273 17.0677C17.8284 17.235 17.7964 17.4009 17.7331 17.5558C17.6698 17.7107 17.5764 17.8515 17.4584 17.9701C17.3403 18.0887 17.1999 18.1827 17.0454 18.2467C16.8908 18.3108 16.725 18.3435 16.5577 18.3432C16.3904 18.3428 16.2248 18.3093 16.0705 18.2445C15.9162 18.1798 15.7762 18.0851 15.6587 17.966L11.3575 13.6782C11.2389 13.5607 11.1447 13.4208 11.0804 13.2666C11.0162 13.1125 10.9831 12.9471 10.9831 12.7801C10.9831 12.6131 11.0162 12.4477 11.0804 12.2936C11.1447 12.1394 11.2389 11.9995 11.3575 11.882L15.124 8.12298H8.75047V17.0397C8.75331 17.2097 8.72192 17.3785 8.65817 17.5362C8.59443 17.6938 8.49962 17.8369 8.3794 17.9572C8.25918 18.0774 8.11601 18.1722 7.9584 18.2359C7.80079 18.2997 7.63196 18.3311 7.46197 18.3282L7.33447 18.3237C7.01449 18.2959 6.71688 18.1481 6.50139 17.9099C6.2859 17.6718 6.16848 17.3609 6.17272 17.0397V7.04223C6.17272 6.24273 6.74497 5.65698 7.51972 5.65698H17.1025Z", fill: color }));
}
exports["default"] = req;
//# sourceMappingURL=req.js.map